import ShareManager from './ShareManager';

export default ShareManager;
